/**
 * @param config - 需要获取的配置
 *
 * @returns 当前域名对应的配置
 *
 * 获取当前域名对应的配置
 */
export const getBaseConfigByOrigin = (config: string) => {
  // 匹配完整的HTTP/HTTPS URL或协议相对URL（以//开头）
  const isUrl = config.match(/^(https?:)?\/\//);

  if (isUrl) {
    // 如果是完整URL，直接返回
    return config;
  }

  // 如果不是URL，判断是否是json字符串，如果是，则返回当前域名的对应值
  const isJson = config.startsWith('{') && config.endsWith('}');
  if (isJson) {
    try {
      const json = JSON.parse(config);
      const host = window.location.host;
      return json[`//${host}`] || `//${window.location.host}`;
    } catch (error) {
      console.error(error);
      return `//${window.location.host}`;
    }
  }

  return `//${window.location.host}`;
};
